import { render, staticRenderFns } from "./VendorPaymentsMade.vue?vue&type=template&id=1b6bf5fc"
import script from "./VendorPaymentsMade.vue?vue&type=script&lang=js"
export * from "./VendorPaymentsMade.vue?vue&type=script&lang=js"
import style0 from "./VendorPaymentsMade.vue?vue&type=style&index=0&id=1b6bf5fc&prod&lang=scss"
import style1 from "./VendorPaymentsMade.vue?vue&type=style&index=1&id=1b6bf5fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports